<template>
  <Fragment>
    <slot />
  </Fragment>
</template>
<script>
import { defineComponent } from 'vue-demi'
import { Fragment } from 'vue-frag'

const HKLFragment = defineComponent({
  name: 'HKLFragment',
  components: {
    Fragment,
  },
})

export default HKLFragment
</script>
